export const LINK_HEIGHT_DEFAULT = 50;
export const LINK_HEIGHT_NARROW = 40;

export const ITEM_TYPE = {
  link: 'link',
  submenu: 'submenu',
  spacer: 'spacer',
};
